import { ProductSizeInterface } from '../../../../../../../Interface/ProductSize';
import { ProductAttributeInterface } from '../../../../../../../Interface/ProductAttribute';
import { VtsInfo } from '../../../../../../../Interface/Vts';

function applyVtsOverrideToProductSize(
  item: ProductSizeInterface
): ProductSizeInterface {
  const vtsInfo: VtsInfo | undefined = item.vts_info;
  if (!vtsInfo) return item;

  const hasDiscount = vtsInfo.discount > 0;
  const hasRegularDiff = vtsInfo.regular_price !== vtsInfo.current_price;

  return {
    ...item,
    current_price: vtsInfo.current_price,
    price: vtsInfo.current_price,
    price_regular: vtsInfo.regular_price,
    promo_percent: hasDiscount ? vtsInfo.discount : item.promo_percent,
    promo_text: vtsInfo.promotion_text || item.promo_text,
    price_is_red: hasDiscount,
    price_show_regular: hasRegularDiff,
    // Bei echter VTS-Promo gewinnt sie über bestehende Linedrive-/Buy-X-Get-Y-
    // Promos (sonst zeigt PromoBadge "3+1" statt des VTS-Prozentwerts).
    promo_plus_condition_count: hasDiscount
      ? undefined
      : item.promo_plus_condition_count,
    promo_free_product_count: hasDiscount
      ? undefined
      : item.promo_free_product_count,
    promo_same_product: hasDiscount ? undefined : item.promo_same_product,
    promo_product_name: hasDiscount ? undefined : item.promo_product_name,
  };
}

export function applyVtsOverridesToProductSizes(
  items: ProductSizeInterface[]
): ProductSizeInterface[] {
  return items.map(applyVtsOverrideToProductSize);
}

export function applyVtsOverridesToProductAttributes(
  items: ProductAttributeInterface[]
): ProductAttributeInterface[] {
  return items.map((attr) => {
    const vtsInfo = attr.product_size?.vts_info;
    if (!vtsInfo) return attr;

    // Wenn der Aussteller eine echte VTS-Promo hat, gewinnt sie über
    // bestehende Flavour-Promos (Clearance / combined). Sonst bleiben
    // die bestehenden Promos sichtbar — z.B. ein Clearance-Flavour
    // bei einem Aussteller ohne VTS-Aktion.
    // TODO (I-6179-Folge): Symptom-Fix. Der saubere Refactor zieht das
    // Promo-Gate aus AttributePrice in die Aufrufer.
    const hasVtsDiscount = vtsInfo.discount > 0;

    return {
      ...attr,
      clearance_discount_percent: hasVtsDiscount
        ? 0
        : attr.clearance_discount_percent,
      combined_discount_percent: hasVtsDiscount
        ? undefined
        : attr.combined_discount_percent,
      combined_price: hasVtsDiscount ? undefined : attr.combined_price,
      combined_description_1: hasVtsDiscount
        ? undefined
        : attr.combined_description_1,
      product_size: applyVtsOverrideToProductSize(attr.product_size),
    };
  });
}

export function buildErpIdToIdMap(
  productSizes: ProductSizeInterface[],
  productAttributes: ProductAttributeInterface[]
): Map<number, number> {
  const map = new Map<number, number>();

  productSizes.forEach((ps) => {
    ps.product_attributes?.forEach((pa) => {
      map.set(pa.erp_id, pa.id);
    });
  });

  productAttributes.forEach((pa) => {
    map.set(pa.erp_id, pa.id);
  });

  return map;
}